export enum LanguageKey {
  English = 'E',
  Spanish = 'S',
}
